import { useAuthStore } from '../../../stores/authStore';
import { useSettings } from '../../../hooks/useSettings';
import { BillingSection } from '../../../components/settings/BillingSection';
import { SettingsSubPage } from '../components/SettingsSubPage';
import { Skeleton } from '../../../components/common/Skeleton';
import { palette, admin } from '../../../styles/tokens';

export function SubscriptionPage() {
  const authBusiness = useAuthStore(s => s.business);
  const { business, teamCounts, loading, error } = useSettings(authBusiness?.id);

  if (loading || (!business && !error)) {
    return (
      <SettingsSubPage title="Your subscription" description="Current plan, upgrade, billing history">
        <div style={{ background: palette.white, borderRadius: admin.cardRadius, border: `1px solid ${admin.border}`, padding: 20 }}>
          <Skeleton width={140} height={14} style={{ marginBottom: 10 }} />
          <Skeleton width={220} height={22} style={{ marginBottom: 18 }} />
          <Skeleton width="100%" height={1} style={{ marginBottom: 16, background: palette.g100 }} />
          <Skeleton width="60%" height={13} style={{ marginBottom: 8 }} />
          <Skeleton width="40%" height={13} style={{ marginBottom: 8 }} />
          <Skeleton width="50%" height={13} />
        </div>
      </SettingsSubPage>
    );
  }

  if (error || !business) {
    return (
      <SettingsSubPage title="Your subscription" description="Current plan, upgrade, billing history">
        <div style={{ padding: 40, textAlign: 'center', color: palette.red, fontSize: 13.5 }}>{error ?? 'Not found'}</div>
      </SettingsSubPage>
    );
  }

  return (
    <SettingsSubPage title="Your subscription" description="Current plan, upgrade, billing history">
      <BillingSection business={business} teamTotal={teamCounts.total} />
    </SettingsSubPage>
  );
}
